import { PageWithScene } from "@/components/PageWithScene/PageWithScene";

export function UnauthorizedError() {
  return <PageWithScene heading="Ingen tilgang" scene="Alice-Bob" />;
}
